<template>
  <div class="cms-youtube-cid">
    <el-dialog
      title="Insert a new Licence Key"
      :visible="dialog"
      width="500px"
      top="3vh"
      :modal="true"
      @close="setDialog(false)"
      @open="open"
    >
      <el-form label-position="top">
        <el-form-item label="Label" prop="label">
          <el-select class="mt10" v-model="keyword.label" clearable filterable>
            <el-option
                v-for="label in asset_labels"
                :key="label.id"
                :value="label.name"
                :label="`${label.name}`"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Licence Key" prop="keywords">
          <el-input type="text" v-model="keyword.keywords" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          size="mini"
          :loading="loading"
          @click="submit()"
        >
          Save
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      active: false
    }
  },
  computed: {
    ...mapState('youtubeKeywords', ['dialog', 'loading', 'keyword', 'asset_labels']),
  },

  methods: {
    ...mapActions('youtubeKeywords', ['insert', "readAssetLabels"]),
    ...mapMutations('youtubeKeywords', ['setDialog']),

    submit() {
      this.insert()
    },

    open(){
      this.readAssetLabels()
    },

  }
}
</script>

<style scoped lang="scss">

</style>
